/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageSettingDto
 */
export interface PageSettingDto {
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    chtName?: string;
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    cnName?: string;
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    content?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PageSettingDto
     */
    enable?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PageSettingDto
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    engName?: string;
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    iconFileName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PageSettingDto
     */
    startTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof PageSettingDto
     */
    url?: string;
}

export function PageSettingDtoFromJSON(json: any): PageSettingDto {
    return PageSettingDtoFromJSONTyped(json, false);
}

export function PageSettingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageSettingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'chtName': !exists(json, 'chtName') ? undefined : json['chtName'],
        'cnName': !exists(json, 'cnName') ? undefined : json['cnName'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'enable': !exists(json, 'enable') ? undefined : json['enable'],
        'endTime': !exists(json, 'endTime') ? undefined : (new Date(json['endTime'])),
        'engName': !exists(json, 'engName') ? undefined : json['engName'],
        'iconFileName': !exists(json, 'iconFileName') ? undefined : json['iconFileName'],
        'startTime': !exists(json, 'startTime') ? undefined : (new Date(json['startTime'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function PageSettingDtoToJSON(value?: PageSettingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'chtName': value.chtName,
        'cnName': value.cnName,
        'code': value.code,
        'content': value.content,
        'enable': value.enable,
        'endTime': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'engName': value.engName,
        'iconFileName': value.iconFileName,
        'startTime': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'url': value.url,
    };
}

